import { ActionMessages, ACTIONS } from '@root/src/types/common';
import { SstFront } from './type';

export const sstActionMessages: ActionMessages<SstFront> = {
  [ACTIONS.CREATE]: {
    successTitleKey: 'api.sst.create.successTitle',
    successDescriptionKey: 'api.sst.create.successDescription',
    formatMessage: (data: SstFront) => {
      const spaceObject = data?.spaceObject;
      return {
        spaceObjectName: spaceObject?.name || 'sst.isUnknownSpaceObject.label',
      };
    },
  },
};
